import React, { useState } from 'react';
import { useTimeTracking } from '../context/TimeTrackingContext';
import offlineTrackingService from '../services/offlineTrackingService';

const OfflineSyncDebug = () => {
  const { isOnline, pendingUpdates } = useTimeTracking();
  const [showDebug, setShowDebug] = useState(false);
  const [debugData, setDebugData] = useState(null);

  const loadDebugData = () => {
    const data = offlineTrackingService.exportData();
    setDebugData(data);
  };

  const clearOfflineData = () => {
    offlineTrackingService.clearActiveSession();
    localStorage.removeItem('pendingTrackingUpdates');
    setDebugData(null);
    alert('Offline data cleared');
  };

  const runCleanup = () => {
    offlineTrackingService.cleanup();
    loadDebugData();
    alert('Cleanup completed');
  };

  if (!showDebug) {
    return (
      <div style={{ 
        position: 'fixed', 
        bottom: '20px', 
        right: '20px', 
        zIndex: 1000 
      }}>
        <button
          onClick={() => setShowDebug(true)}
          style={{
            padding: '5px 10px',
            backgroundColor: isOnline ? '#28a745' : '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '3px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          🔧 {isOnline ? 'Online' : 'Offline'} {pendingUpdates > 0 && `(${pendingUpdates})`}
        </button>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      width: '300px',
      backgroundColor: 'white',
      border: '1px solid #ccc',
      borderRadius: '5px',
      padding: '10px',
      zIndex: 1000,
      fontSize: '12px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
        <strong>Offline Sync Debug</strong>
        <button onClick={() => setShowDebug(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
      </div>
      
      <div style={{ marginBottom: '10px' }}>
        <div>Status: {isOnline ? '🟢 Online' : '🔴 Offline'}</div>
        <div>Pending Updates: {pendingUpdates}</div>
      </div>
      
      <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
        <button onClick={loadDebugData} style={{ padding: '3px 6px', fontSize: '11px' }}>
          Load Data
        </button>
        <button onClick={clearOfflineData} style={{ padding: '3px 6px', fontSize: '11px' }}>
          Clear
        </button>
        <button onClick={runCleanup} style={{ padding: '3px 6px', fontSize: '11px' }}>
          Cleanup
        </button>
      </div>
      
      {debugData && (
        <div style={{ 
          maxHeight: '200px', 
          overflow: 'auto', 
          backgroundColor: '#f8f9fa', 
          padding: '5px',
          borderRadius: '3px'
        }}>
          <div><strong>Active Session:</strong></div>
          <div>{debugData.activeSession ? 'Yes' : 'None'}</div>
          
          <div style={{ marginTop: '5px' }}><strong>Offline Sessions:</strong></div>
          <div>{debugData.offlineSessions.length} sessions</div>
          
          <div style={{ marginTop: '5px' }}><strong>Storage:</strong></div>
          <div>{Math.round(debugData.storageInfo.totalSize / 1024)} KB used</div>
          
          {debugData.activeSession && (
            <div style={{ marginTop: '5px' }}>
              <div><strong>Current:</strong></div>
              <div>Elapsed: {Math.floor((debugData.activeSession.elapsedTime || 0) / 60)}m</div>
              <div>Idle: {Math.floor((debugData.activeSession.totalIdleTime || 0) / 60)}m</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OfflineSyncDebug;